var map = {
	"./breakout/icon.png": 8593,
	"./dots/icon.png": 4542,
	"./hexa/icon.png": 1101,
	"./knife/icon.png": 9131,
	"./match3/icon.png": 6097,
	"./solitaire/icon.png": 8295,
	"./spider/icon.png": 9800,
	"./sudoku/icon.png": 9479,
	"./td/icon.png": 5857,
	"./wordscapes/icon.png": 61
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6656;